import React from 'react';

import PropTypes from 'prop-types';

import {
  hollowLink,
  solidLink
} from './style';

const propTypes = {
  isHollow: PropTypes.bool,
  href: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const LinkButton = React.forwardRef((props, ref) => {
  LinkButton.displayName = 'LinkButton';

  const {
    href,
    isHollow,
    children
  } = props;
  return (
    <a
      ref={ref}
      href={href}
      className={isHollow ? hollowLink : solidLink}
    >
      {children}
    </a>
  );
});

LinkButton.propTypes = propTypes;

export default LinkButton;
